import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import ExperienceRecordsTableWithFilters from './ExperienceRecordsTableWithFilters.tsx';

const ExperienceRecordListPage = (): JSX.Element => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId="experience-records.list-page.title"
                    showBreadcrumb
                    buttons={
                        <div>
                            <ListCreateButton
                                permissions={['CREATE.EXPERIENCE_RECORDS.ALL']}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => navigateWithReturn('/experience-records/new')}
                                labelId="experience-records.list-page.add-new"
                                newLabelId="new-entity.experience-record"
                            />
                        </div>
                    }
                />
                <ExperienceRecordsTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default ExperienceRecordListPage;
